// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"479":"b286ee7c","707":"c3b7dc42"}[chunkId] + ".chunk.js";
};